<template>
  <div class="base-mit-chart-bar">
      <canvas id="mitChartBarId"></canvas>
  </div>
</template>

<script>
  import Chart from 'chart.js/auto';

export default {
  name: 'BaseMitChartBar',
  components: {
  },
  props: {
    barData:{
        default: {
            labels:[],
            values:[]
        },
        type: Object
    },
    title: {
        default: 'Default Title',
        type: String
    },
    labelX:{
        default: 'Default X Label',
        type: String
    },
    labelY:{
        default: 'Default Y Label',
        type: String
    },
    horizontal:{
        default: false,
        type: Boolean
    },
    backgroundColor: {
        default() {
            return [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(153, 102, 255, 0.2)'
            ]
        },
        type: Array
    },
    borderColor: {
        default() {
            return [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)'
            ]
        },
        type: Array
    }
  },
  data: function() {
    return {
    }
  },
  created() {
  },
  mounted() {
      const ctxLine = document.getElementById('mitChartBarId');
      const line = new Chart(ctxLine, {
            type: 'bar',
            data: {
                labels: this.barData.labels,
                datasets: [{
                    label: this.labelX,
                    data: this.barData.values,
                    backgroundColor: this.backgroundColor,
                    borderColor: this.borderColor,
                    borderWidth: 1
                }]
            },
            options: {
                indexAxis: this.horizontal ? 'y' : 'x',
                responsive: true,
                plugins: {
                  legend: {
                    position: 'none',
                  },
                  title: {
                    display: true,
                    text: this.title
                  }
                },
                scales: {
                    // x: {
                    //     ticks: {
                    //         // Include a dollar sign in the ticks
                    //         callback: (index) => {
                    //             let label = this.barData.labels[index];
                    //             if(label.length > 20){
                    //                 let arr = label.split('/');
                    //                 return '.../'+arr[arr.length-1];
                    //             }
                    //             return label;
                    //         }
                    //     }
                    // },
                    y: {
                        beginAtZero: false,
                        title: {
                            display: true,
                            text: this.labelY
                        },
                        //type: 'logarithmic'
                    }
                }
            }
        });
  },
  methods : {

  }
}
</script>

<style lang="scss" scoped>

</style>
